import { Link } from 'react-router-dom';
import styles from './Payments.module.css';

/** Staff order identity; public shipment UUIDs are never presentation labels. */
export function OrderLabel({
  shipmentId,
  orderNumber,
  route,
  vehicleNumber,
  newTab = false,
}: {
  shipmentId: number;
  orderNumber?: number | null;
  route?: string | null;
  vehicleNumber?: string | null;
  newTab?: boolean;
}) {
  return (
    <span>
      <Link
        className={styles.orderLink}
        to={`/shipments/${shipmentId}`}
        target={newTab ? '_blank' : undefined}
        rel={newTab ? 'noreferrer' : undefined}
      >
        #{orderNumber ?? shipmentId}
      </Link>
      {route && <> · {route}</>}
      {vehicleNumber && <> · {vehicleNumber}</>}
    </span>
  );
}
